// test1367
(1367 && 0);
